// removed by extract-text-webpack-plugin
module.exports = {"toast-message-container":"ToastContainer__toast-message-container","toastMessageContainer":"ToastContainer__toast-message-container","top-down":"ToastContainer__top-down","topDown":"ToastContainer__top-down","down-top":"ToastContainer__down-top","downTop":"ToastContainer__down-top"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ToastContainer/ToastContainer.css
// module id = 537
// module chunks = 8